import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import JsBarcode from "jsbarcode";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import Moment from "moment";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CurrencySymbols from "../../../common/CurrencySymbol";
import CurrencySymbolReports from "../../../common/Reportcurrencysymbols";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import { toastWarn } from "../../../common/Toast";
import CommonTabular from "../../../components/Datatable/CommonTabular";

const BalanceSheetDetail = (props) => {
  const token = localStorage.getItem("Token");
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    currencySymbolLocation,
  } = useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const locationid = localStorage.getItem("Location");
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [nemultiselect, setnemultiselect] = useState({
    TransactionType: [],
  });
  const [columnOrder, setColumnOrder] = useState([]);
  const [columnVisibility, setColumnVisibility] = useState({});

  //----------------Server-Side------------------//
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const loginuserid = localStorage.getItem("ID");

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };

  //Function for lookup receipt
  const paramObject = useParams();
  const apicall = () => {
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return { columnname: el.id, value: el.value, id: index + 1 };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    setLoading(true);
    setResponseData([]);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/balancesheetdetail?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&loginId=${loginuserid}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          if (res.data.ResponseData.length > 0) {
            const data = res.data.ResponseData;
            const mainData = data?.map((el) => {
              return {
                ...el,
                Name: el?.Name ? el?.Name : "",
                Num: el?.Num ? el?.Num : "",
                Credit: Number(el?.Credit) || 0,
                Debit: Number(el?.Debit) || 0,
                Amount: Number(el?.Amount) || 0,
                Balance: Number(el?.Balance) || 0,
              };
            });
            setResponseData(data);
          } else {
            toastWarn("No Records found!");
          }
          setLoading(false);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);
  };

  const columns = [
    {
      header: "Date",
      accessorKey: "Date",
      size: "120",
      filterFn: "contains",
      Cell: ({ row }) => {
        const dateValue = row.original.Date;
        const formattedDate =
          dateValue && Moment(dateValue).isValid()
            ? Moment(dateValue).format(`${dateFormate.toUpperCase()}`)
            : "";
        return formattedDate;
      },
    },
    {
      header: "Transaction Type",
      accessorKey: "TransactionType",
      filterSelectOptions: nemultiselect?.TransactionType, // ["paid", "unpaid"],
      filterVariant: "multi-select", //"select",
      enableColumnFilterModes: false,
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={{
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontWeight: "700",
          }}
          onClick={() => {
            const url =
              row.original?.TransactionType === "Payment"
                ? `/receive-payment/${row.original.TxnId}`
                : row.original?.TransactionType === "Invoice" ||
                  row.original?.TransactionType === "Credit Memo"
                ? `/sales-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Bill" ||
                  row.original?.TransactionType === "Supplier Return" ||
                  row.original?.TransactionType === "Vendor Credit"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Journal"
                ? `/journal-entry/${row.original.TxnId}`
                : row.original?.TransactionType === "Deposit"
                ? `/bank-deposit/${row.original.TxnId}`
                : row.original?.TransactionType === "Expense"
                ? `/receiving-receipt/${row.original.TxnId}`
                : row.original?.TransactionType === "Transfer"
                ? `/manage-transfer/${row.original.TxnId}`
                : row.original?.TransactionType === "Opening Balance"
                ? `/account-report/${row.original.TxnId}`
                : "#";

            window.open(url, "_blank"); // Open in a new tab
          }}
        >
          {row.original.TransactionType}
        </Box>
      ),
    },
    {
      header: "Num",
      accessorKey: "Num",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) =>
        row.original.Num == "0" || "" ? "" : row.original.Num,
    },
    {
      header: "Name",
      accessorKey: "Name",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "AccountName",
      accessorKey: "AccountName",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "ChartOfAccountName",
      accessorKey: "ChartOfAccountName",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "PaymentMethod",
      accessorKey: "PaymentMethod",
      size: "120",
      filterFn: "contains",
    },
    // { accessorKey: "Name" },
    {
      header: "Memo/Description",
      accessorKey: "Description",
      size: "120",
      filterFn: "contains",
    },
    {
      header: "Split",
      accessorKey: "Split",
    },

    {
      header: "Credit",
      accessorKey: "Credit",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TotalCredit = row?.original?.Credit;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalCredit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Debit",
      accessorKey: "Debit",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TotalDebit = row?.original?.Debit;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalDebit),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
    },
    {
      header: "Amount",
      accessorKey: "Amount",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TotalAmount = row?.original?.Amount;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalAmount),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Balance",
      accessorKey: "Balance",
      size: "100",
      filterFn: "contains",
      Cell: ({ row }) => {
        const TotalBalance = row?.original?.Balance;

        return (
          <div style={{ textAlign: "end" }}>
            {CurrencySymbols(
              Number(TotalBalance),
              { CurrencySymbol },
              FractionDigits
            )}
          </div>
        );
      },
      AggregatedCell: ({ cell, table }) => {
        const groupingColumnId = cell.row.groupingColumnId ?? "";
        const originalValue =
          cell.row.original?.[groupingColumnId] ??
          cell.row.subRows?.[0]?.original?.[groupingColumnId];

        // Retrieve the aggregated value
        const aggregatedValue = cell.getValue();

        // Check if the value is valid and format it
        const formattedValue =
          typeof aggregatedValue === "number" ? aggregatedValue : 0;

        return (
          <>
            <Box component="span" sx={{ fontWeight: "bold" }}>
              Total for {originalValue ?? "Unknown"}:
            </Box>{" "}
            <Box
              sx={{ color: "info.main", display: "inline", fontWeight: "bold" }}
            >
              {/* {formattedValue} */}
              {CurrencySymbols(
                Number(formattedValue),
                { CurrencySymbol },
                FractionDigits
              )}
            </Box>
          </>
        );
      },
    },
    {
      header: "Created Date",
      accessorKey: "CreatedDate",
      // size: "140",
      Cell: ({ row }) => {
        const CreatedDate = row?.original?.CreatedDate;
        if (
          CreatedDate === "0000-00-00" ||
          CreatedDate === "" ||
          CreatedDate === null
        ) {
          return "";
        }
        return moment(CreatedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Created By",
      accessorKey: "CreatedBy",
    },
    {
      header: "Last Modified",
      accessorKey: "LastModified",
      // size: "140",
      Cell: ({ row }) => {
        const ModifiedDate = row?.original?.LastModifiedDate;
        if (
          ModifiedDate === "0000-00-00" ||
          ModifiedDate === "" ||
          ModifiedDate === null
        ) {
          return "";
        }
        return moment(ModifiedDate).format(
          `${dateFormate.toUpperCase()} hh:mm A`
        );
      },
    },
    {
      header: "Modified By",
      accessorKey: "ModifiedBy",
    },
    // {
    //   header: "Payment Method",
    //   accessorKey: "PaymentMethod",
    // },
  ];

  const columnsClassic = [
    {
      title: "ChartofAccountType",
      headerFilter: "input",
      field: "ChartofAccountType",
      frozen: true,
      defaultVisible: true,
    },
    {
      title: "Transactiontype",
      headerFilter: "input",
      field: "Transactiontype",
      defaultVisible: true,
    },
    {
      title: "Num",
      headerFilter: "input",
      field: "Num",
      defaultVisible: true,
    },
    {
      title: "Credit",
      headerFilter: "input",
      field: "Credit",
      frozen: true,
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();

        console.log(value, "valuevalue");

        if (value == "0.00" || value === "") {
          return "0.0";
        }

        return CurrencySymbolReports(
          isNaN(value) ? 0 : Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Debit",
      headerFilter: "input",
      field: "Debit",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();

        console.log(value, "valuevalue");

        if (value == "0.00" || value === "") {
          return "0.0";
        }

        return CurrencySymbolReports(
          isNaN(value) ? 0 : Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Amount",
      headerFilter: "input",
      field: "Amount",
      defaultVisible: true,
      bottomCalc: "sum",
      formatter: function (cell) {
        const value = cell.getValue();

        console.log(value, "valuevalue");

        if (value == "0.00" || value === "") {
          return "0.0";
        }

        return CurrencySymbolReports(
          isNaN(value) ? 0 : Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Accounts",
      headerFilter: "input",
      field: "Accounts",
      defaultVisible: true,
    },
  ];

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3>Open Purchase Order List</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Balance Sheet Detail</li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-2 align-self-sm-end">
              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>

            {/* <div
              className="cursor-pointer col-md-3 d-flex justify-content-end mt-5"
              onClick={() =>
                handleSaveColumnOrder(
                  loginuserid,
                  "BalanceSheetReport",
                  columnOrder,
                  token,
                  // []
                  columnVisibility
                )
              }
              title="Lock Your Sequence"
            >
              <i class="fa fa-lock columnsLock fs-4"></i>
            </div> */}
          </div>

          {/* Receipt */}
          {responseData.length > 0 && (
            <div className="card mt-3">
              <div className="card-body">
                <div className="container">
                  <div className="col-md-12 text-center " id="header">
                    <h6 className="p">SonarPos</h6>
                    <p className="fw-bold p-regular">Balance Sheet Detail</p>
                    <div className="row mb-2">
                      {/* <h6> Date: {new Date().toLocaleDateString()}</h6> */}
                      <p>
                        Date:{" "}
                        {startdate === "" && enddate === ""
                          ? "All Data"
                          : moment(startdate).format(
                              `${dateFormate.toUpperCase()}`
                            ) +
                            " - " +
                            moment(enddate).format(
                              `${dateFormate.toUpperCase()}`
                            )}
                      </p>
                    </div>
                  </div>
                </div>
                <hr />

                <div>
                  {/* <CommonMatrialReactTable
                    MainHeading="Sonar POS"
                    ReportHeading="Trial Balance Report"
                    columns={columns}
                    data={responseData}
                    startdate={startdate}
                    enddate={enddate}
                    columnGrouping={["ChartOfAccountName", "AccountName"]}
                    enableExpandAll={true}
                    enableExpanding={true}
                    expanded={true}
                    enableRowSelection={false}
                    columnsVisibility={{
                      CreatedDate: false,
                      CreatedBy: false,
                      LastModified: false,
                      ModifiedBy: false,
                    }}
                    // setColumnOrder={setColumnOrder}
                    // setColumnVisibility = {setColumnVisibility}
                    // state={{
                    //   columnOrder,
                    //   columnVisibility,
                    // }}
                    // rowCount = {rowCount}
                  /> */}
                  <CommonTabular
                    Data={responseData}
                    columns={columnsClassic}
                    Groupvalue={["ChartofAccountType", "Accounts"]}
                    Reportname={"DemoReport"}
                    frozenRowvalue={0}
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default BalanceSheetDetail;
